module.exports = "\n\n<div *ngIf='this.isImageCatalog'>\n  <h1>Caricamento Immagine...</h1>\n  <h2>Load image...</h2>\n</div>\n\n<div *ngIf='!this.isImageCatalog'>\n  <h1>Caricamento Prodotto...</h1>\n  <h2>Load product...</h2>\n</div>\n\n<i class=\"fa fa-circle-o-notch fa-spin fa-fw\" style=\"font-size: 100px; color: #509e2f; margin: 14px 0;\"></i>\n\n<!-- <div *ngFor=\"let prod of this.config.products\">\n      {{ this.prod.id }} - {{ this.prod.name }}<br>\n</div> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/load-product.component.html
// module id = 608
// module chunks = 1